import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import ListSelector from "./ListSelector";
import axios from "axios";
import {StoreContext} from "../../../stores/contexts";

class SectionSelector extends Component {
  static contextType = StoreContext;

  constructor(props) {
    super(props);
    this.state={
      inited:false,
      fields:[],
      detail:{},
    };
  }
  componentDidMount() {
    /*axios.post(this.props.field.list_route,{ items_per_page:999999, page:1 }).then((data)=>{
      this.setState({ fields: data.data.answer.items, inited: true });
    });*/
  }

  inputRef(ref) {
    if(this.props.inputRef) {
      this.props.inputRef(ref);
    }
  }
  getList(str,callback) {
    const cat=this.context.configStore.config.data.category;
    const name=encodeURIComponent('%'+str.replace(/\ /gi, "%")+'%');
    axios.get(`/sysapi/dynamic/${cat}/sections?filter[~name]=${name}`).then((data)=>{
      console.log('data',data);
      callback(data.data.answer.items || []);
    })
  }
  getById(val) {
    const cat=this.context.configStore.config.data.category;
    axios.get(`/sysapi/dynamic/${cat}/sections?filter[id]=${val}`).then((data) => {
      this.setState({ detail:data.data.answer.items ? data.data.answer.items[0] : {} });
    });
  }
  render() {
    return (
      <ListSelector
        inputRef={(ref)=>{ this.inputRef(ref); }}
        titleValue={this.state.detail.name}
        filterFunction={(str,callback)=>{
          this.getList(str,callback);
        }}
        idField={"id"}
        titleField={"name"}
        onNewFied={()=>{
          this.props.onNewFied();
        }}
        onCancel={()=>{
          this.props.onCancel();
        }}
        onSelect={(item)=>{
          this.getById(item.id);
          this.props.item.value=item.id;
          this.props.item.focus=1;
        }}
      />
    )
  }
}

// export default inject("configStore")(observer(SectionSelector));
export default observer(SectionSelector);